import React from 'react';
import { InitialData } from 'src/types';
import useQuery from 'src/hooks/useQuery';
import { ApiRoutes } from 'src/lib/routes';
import { useLocale } from 'next-intl';

const DEFAULT_INITIAL_DATA: InitialData = {
  affiliateCappedAmount: {},
  giftCollections: [],
  countries: [],
  cities: [],
  currentGeolocation: {
    countryCode: null
  },
  exchangeRates: [],
  checkoutSupportedCurrencies: [],
  settings: {},
  siteBanners: [],
  suitableGroups: []
};

export const InitialDataContext = React.createContext<InitialData>(DEFAULT_INITIAL_DATA);

const InitialDataProvider: React.ReactFCWithChildren = ({ children }) => {
  const locale = useLocale();
  const result = useQuery<InitialData>(ApiRoutes.apiInitialDataRoute({},{next_locale: locale}).toUrl());
  const initialData = (result.data || DEFAULT_INITIAL_DATA) as InitialData;
  return <InitialDataContext.Provider value={initialData}>{children}</InitialDataContext.Provider>;
};

export default InitialDataProvider;
